import { LazyExoticComponent, lazy } from 'react';

interface Route {
    path: string,
    element: LazyExoticComponent<() => JSX.Element>,
    name: string;
    children?: Route[]
}

const Login = lazy(() => import('./pages/auth/Login'));
const Registro = lazy(() => import('./pages/auth/Registro'));
const Recuperacion = lazy(() => import('./pages/auth/Recuperacion'));

const Inicio = lazy(() => import('./pages/app/Inicio'));
const Perfil = lazy(() => import('./pages/app/Perfil'));
const Personales = lazy(() => import('./pages/app/curriculum/DatosPersonales'));
const Familiares = lazy(() => import('./pages/app/curriculum/DatosFamiliares'));
const Educacion = lazy(() => import('./pages/app/curriculum/Educacion'));
const Oferta = lazy(() => import('./pages/app/curriculum/Oferta'));
const Trayectoria = lazy(() => import('./pages/app/curriculum/Trayectoria'));
const Otros = lazy(() => import('./pages/app/curriculum/Otros'));
const DetalleInformacion = lazy(() => import('./pages/app/curriculum/Navigation'));
const Imprimir = lazy(() => import('./pages/app/Imprimir'));
const Update = lazy(() => import('./pages/auth/Update'));


export const authRoutes: Route[] = [
    {
        path: '/',
        element: Login,
        name: 'Login'
    },
    {
        path: '/hojadevida/registro',
        element: Registro,
        name: 'Registro'
    },
    {
        path: '/hojadevida/recuperacion',
        element: Recuperacion,
        name: 'Recuperacion'
    },
    {
        path: '/hojadevida/update/:id',
        element: Update,
        name: 'Update'
    },
    {
        path: '/hojadevida',
        element: Login,
        name: 'Login'
    },
];

export const appRoutes: Route[] = [
    {
        path: '/inicio',
        element: Inicio,
        name: 'Inicio'
    },
    {
        path: '/hojadevida/perfil',
        element: Perfil,
        name: 'Perfil'
    },
    {
        path: '/hojadevida/personales',
        element: Personales,
        name: 'Personales'
    },
    {
        path: '/hojadevida/familiares',
        element: Familiares,
        name: 'Familiares'
    },
    {
        path: '/hojadevida/educacion',
        element: Educacion,
        name: 'Educacion'
    },
    {
        path: '/hojadevida/oferta',
        element: Oferta,
        name: 'Oferta'
    },
    {
        path: '/hojadevida/trayectoria',
        element: Trayectoria,
        name: 'Trayectoria'
    },
    {
        path: '/hojadevida/otros',
        element: Otros,
        name: 'Otros'
    },
    {
        path: '/hojadevida/detalle_informacion',
        element: DetalleInformacion,
        name: 'DetalleInformacion'
    },
    {
        path: '/hojadevida/imprimir',
        element: Imprimir,
        name: 'Imprimir'
    },

]